/**
 * Tokens de diseño Pinpeo (propuesta "Panel de transacciones autoajustable").
 * Única fuente de verdad de colores/tipografía/radios para todo el panel.
 */
export const PINPEO = {
  // Marca
  brandDark: '#282828',      // top bar / superficies de marca
  primary: '#0E7C43',        // acción principal
  primaryHover: '#0A5C33',
  primarySoft: '#E7F2EC',    // fondos suaves (avatar, pills de conteo)

  // Superficies
  background: '#F7FAF8',
  surface: '#FFFFFF',

  // Bordes y divisores
  border: '#E1E8E4',
  borderStrong: '#D4DED8',
  divider: '#EDF2EF',
  track: '#E7EDE9',          // fondo de grupos de chips/segmentos

  // Texto
  text: '#16211B',
  textSoft: '#3C4A42',
  textSecondary: '#5B6B62',
  textMuted: '#8A968F',
  textFaint: '#B7C2BB',

  // Filas de tabla
  rowHover: '#F0F7F3',
  rowSelected: '#EDF6F0',

  // Sombras
  shadowCard: '0 8px 28px rgba(11,61,38,.08)',
  shadowPopover: '0 16px 40px rgba(11,61,38,.18)',

  // Radios
  radius: 10,
  radiusCard: 14,

  // Tipografías
  fontFamily: '"Instrument Sans", "Roboto", "Helvetica", "Arial", sans-serif',
  fontFamilyMono: '"IBM Plex Mono", "Roboto Mono", monospace',
};

/**
 * Pills de estado (variant semántico -> colores de la propuesta).
 * success: Aprobada · warning: Pendiente · error: Rechazada · info: Reembolso.
 */
export const STATUS_PILL = {
  success: { bg: '#E1F4E8', fg: '#0E7C43' },
  warning: { bg: '#FCF3DC', fg: '#9A6B0B' },
  error: { bg: '#FBE7E5', fg: '#B3392E' },
  info: { bg: '#E8EDF6', fg: '#3D5A99' },
  default: { bg: '#EDF2EF', fg: '#5B6B62' },
};

export default PINPEO;
